import { Product } from 'models/product';
import client from './client';

export const getProductsSession = () => client.get<Product[]>(`orders/ms/v1/products`);

export const updateProduct = (id: string, data: any) =>
  client.put(`orders/ms/v1/products/${id}`, data);
